import { UserCheck, Bot } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "../ui/card";
import { Button } from "../ui/button";
import { Badge } from "../ui/badge";

export const HumanTakeoverCard = ({ takeoverThreads, onResume }) => {
  if (!takeoverThreads.length) return null;
  return (
          <Card className="border-sky-200 bg-sky-50" data-testid="human-takeover-card">
            <CardHeader>
              <CardTitle className="text-lg flex items-center gap-2 text-sky-800">
                <UserCheck className="w-5 h-5 text-sky-600" />
                Human Agent Handling ({takeoverThreads.length})
              </CardTitle>
              <CardDescription className="text-sky-700">
                A TalentDesk agent replied in these chats, so the AI has stepped back. Resume AI if the agent is done.
              </CardDescription>
            </CardHeader>
            <CardContent>
              <div className="space-y-2">
                {takeoverThreads.slice(0, 10).map((thread) => (
                  <div
                    key={thread.thread_id}
                    className="flex items-center justify-between p-3 rounded-lg bg-white border border-sky-100"
                    data-testid={`takeover-thread-${thread.thread_id}`}
                  >
                    <div className="flex-1 min-w-0">
                      <div className="flex items-center gap-2">
                        <Badge variant="outline" className="text-xs border-sky-200 text-sky-700">
                          Agent {thread.agent_actor_id || "unknown"}
                        </Badge>
                        <span className="text-xs text-slate-500">Thread: {thread.thread_id}</span>
                      </div>
                      {thread.agent_message_preview && (
                        <p className="text-sm text-slate-700 mt-1 line-clamp-1">
                          "{thread.agent_message_preview}"
                        </p>
                      )}
                      <p className="text-xs text-slate-500 mt-1">
                        Took over: {new Date(thread.taken_over_at).toLocaleString()}
                      </p>
                    </div>
                    <Button
                      size="sm"
                      variant="outline"
                      className="gap-1 border-emerald-200 text-emerald-700 hover:bg-emerald-50"
                      onClick={() => onResume(thread.thread_id)}
                      data-testid={`resume-ai-${thread.thread_id}`}
                    >
                      <Bot className="w-3 h-3" />
                      Resume AI
                    </Button>
                  </div>
                ))}
              </div>
            </CardContent>
          </Card>
  );
};
